module.exports = __webpack_public_path__ + "media/images/twitter-354239fc80db5c6088a06f410faf9c1f.png";